declare global {
  interface Window {
    __APP_ENV__?: {
      VITE_SUPABASE_URL: string;
      VITE_SUPABASE_ANON_KEY: string;
      VITE_SITE_URL: string;
    };
  }
}

const supabaseUrl    = import.meta.env.VITE_SUPABASE_URL    ?? window.__APP_ENV__?.VITE_SUPABASE_URL    ?? '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? window.__APP_ENV__?.VITE_SUPABASE_ANON_KEY ?? '';
const siteUrl        = import.meta.env.VITE_SITE_URL        ?? window.__APP_ENV__?.VITE_SITE_URL        ?? '';
const source         = import.meta.env.VITE_SUPABASE_URL ? 'build-time' : 'runtime-fallback';

export const config = { supabaseUrl, supabaseAnonKey, siteUrl, source } as const;

export function assertRequiredConfig(): void {
  const missing: string[] = [];
  if (!config.supabaseUrl)    missing.push('VITE_SUPABASE_URL');
  if (!config.supabaseAnonKey) missing.push('VITE_SUPABASE_ANON_KEY');
  if (missing.length > 0) {
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`);
  }
}
